export function initHeader() {
    const mobileToggle = document.getElementById('mobile-menu-toggle-inner');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileClose = document.getElementById('mobile-menu-close');

    // Desktop Dropdown Hover (toggle arrow icons and show submenu)
    const dropdownTriggers = document.querySelectorAll('.dropdown-trigger');
    dropdownTriggers.forEach(trigger => {
        const submenu = trigger.querySelector('.submenu, .submenu-grid');
        const arrowDown = trigger.querySelector('.arrow-down');
        const arrowUp = trigger.querySelector('.arrow-up');
        // Find text span/p, excluding arrow spans
        const span = trigger.querySelector('span:not(.arrow-down):not(.arrow-up), p');

        if (!submenu) return;

        trigger.addEventListener('mouseenter', () => {
            submenu.classList.remove('hidden');
            submenu.classList.add('flex');
            // Show up arrow, hide down arrow
            arrowDown?.classList.add('hidden');
            arrowUp?.classList.remove('hidden');
            // Add red color to text
            span?.classList.add('text-cil-red');
        });

        trigger.addEventListener('mouseleave', () => {
            submenu.classList.add('hidden');
            submenu.classList.remove('flex');
            // Show down arrow, hide up arrow
            arrowDown?.classList.remove('hidden');
            arrowUp?.classList.add('hidden');
            // Remove red color
            span?.classList.remove('text-cil-red');
        });
    });

    // Function to close mobile menu
    const closeMobileMenu = () => {
        if (mobileMenu) {
            mobileMenu.classList.add('hidden');
            mobileMenu.classList.remove('flex');
            document.body.style.overflow = '';
        }
    };

    // Function to open mobile menu
    const openMobileMenu = () => {
        if (mobileMenu) {
            mobileMenu.classList.remove('hidden');
            mobileMenu.classList.add('flex');
            document.body.style.overflow = 'hidden';
        }
    };

    // Toggle Mobile Menu (hamburger button)
    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', () => {
            const isHidden = mobileMenu.classList.contains('hidden');
            if (isHidden) {
                openMobileMenu();
            } else {
                closeMobileMenu();
            }
        });
    }

    // Close Mobile Menu (X button)
    if (mobileClose) {
        mobileClose.addEventListener('click', closeMobileMenu);
    }

    // Mobile Accordions (click to toggle)
    const mobileTriggers = document.querySelectorAll('.mobile-dropdown-trigger');
    mobileTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            const btn = e.currentTarget as HTMLElement;
            const targetId = btn.getAttribute('data-target');
            const content = targetId ? document.getElementById(targetId) : btn.nextElementSibling as HTMLElement;
            const arrowDown = btn.querySelector('.arrow-down');
            const arrowUp = btn.querySelector('.arrow-up');

            if (content && content.classList.contains('hidden')) {
                content.classList.remove('hidden');
                content.classList.add('block');
                // Toggle arrows
                arrowDown?.classList.add('hidden');
                arrowUp?.classList.remove('hidden');
            } else if (content) {
                content.classList.add('hidden');
                content.classList.remove('block');
                // Toggle arrows back
                arrowDown?.classList.remove('hidden');
                arrowUp?.classList.add('hidden');
            }
        });
    });
}
